import { SHTypography } from "@components/design-systems";

export const MissingDataCell = () => {
  return (
    <SHTypography
      variant="body3"
      zIndex="1"
      colorVariant="third"
      textAlign="center"
    >
      No data
    </SHTypography>
  );
};
